/**
 * @exports LineChart
 * @fileoverview this file define the LineChart component 
 * @date 2022-08-23
 * @version 1.0 
 * @author Combes Hugo
 */


/*Import necessaries librairies*/
import React, { Component } from 'react';
import moment from "moment";
import _ from "lodash";
import { Line } from 'react-chartjs-2';
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
import {CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title} from 'chart.js'
Chart.register(ArcElement, Tooltip, Legend, CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title);
  

class LineChart extends Component{
    render(){
        let consultants = this.props.data;
        let date=[];

        function formateDate(date){
          if (date){
            return(date.substring(0, 7))
          }
        }
        
        // création des dates en abcisses
        for(let i = 0; i < consultants.length; i++){
          if (date.includes(formateDate( consultants[i].user.sageContent.startDate))) {} else {
            date[i] = (formateDate( consultants[i].user.sageContent.startDate))
          }
        }
        date = date.filter(item => item !== undefined)
        date = date.sort((a,b) => a.localeCompare(b,undefined,{numeric: true}))
        // --- --- ---


        // modification de la date pour éviter les trous
        if(date.length>1) {
          let newDate = []
          let totalMonth = Number(date[date.length-1].substring(0,4) - date[1].substring(0,4))*12 + Number(date[1].substring(5,7)) + Number(date[0].substring(5,7)) + 1
          let startingYear = Number(date[1].substring(0,4))
          for (let i = 1; i < totalMonth; i++){
            newDate.push( startingYear + (Math.trunc(i/12)) +  "-" + getCorrectDateFormat((i%12)+1)   )
          }
          function getCorrectDateFormat(date){
            if (date<10){
              return("0"+date)
            } return (date)
          }
          date = newDate
        }

        //allonger la date jusqu'a aujourd'hui
        if(date.length>1) {
          const dateForm = new Date( date[date.length-1] );
          const today = new Date();
          const diff = moment(dateForm).diff(today, "month");
          //
          let monthInt = parseInt(date[date.length-1][5] +  date[date.length-1][6])
          let yearInt = parseInt(date[date.length-1].substring(0, 4))
          for(let i = 0; i < diff; i++){
            //monthInt = monthInt + 1*
            monthInt = monthInt + 1
            if(monthInt>12){
              monthInt = 1
              yearInt = yearInt + 1
            }
            if(monthInt.length>1){
              date.push( yearInt + "-" + monthInt)
            }else{
              date.push( yearInt + "-0" + monthInt)
            }
          }
        }

        // somme des recrutements ---

        let consultantSomme = new Array(date.length).fill(0)
        _.each(consultants, function(consultant){
          if(consultant.user.sageContent.startDate){
            let startDate = consultant.user.sageContent.startDate.substring(0, 7)
            let index = date.indexOf(startDate)
            if(index > -1){
              for(let i=index; i<date.length; i++){
                consultantSomme[i] = consultantSomme[i] + 1
              }
            }
          }
        })



        let numberOfDate = new Array(date.length).fill(0)
        for (let i = 0; i <date.length; i++){
          for (let y = 0; y < consultants.length; y++){
            if(formateDate( consultants[y].user.sageContent.startDate)===date[i]){
              numberOfDate[i] = numberOfDate[i] + 1
            }
          }
        }
        let consultantSommeOverTime = new Array(date.length).fill(0)
        consultantSommeOverTime[0] = numberOfDate[0]
        for (let i = 1; i <date.length+1; i++){
          consultantSommeOverTime[i] = numberOfDate[i] + consultantSommeOverTime[i-1]
        }
        // --- --- ---



        // consultant actif sur le temps + roll out
        let consultantActive = new Array(date.length).fill(0)
        let rollOut = new Array(date.length).fill(0)
        let totalConsultantRollOut = 0
        for(let i = 0; i < consultants.length; i++){
          if (consultants[i].user.sageContent.startDate){
            totalConsultantRollOut = totalConsultantRollOut + 1
            var indexStart = date.indexOf(formateDate(consultants[i].user.sageContent.startDate));
            // consultant actif
            if (consultants[i].user.sageContent.endDate){
              var indexEnd = date.indexOf(formateDate(consultants[i].user.sageContent.endDate));
              for (let x = indexStart; x <= indexEnd; x++ ){
                consultantActive[x]=consultantActive[x]+1
              }
            }
            else{
              for (let x=indexStart; x < consultantActive.length; x++ ){
                consultantActive[x]=consultantActive[x]+1
              }
            }
            // roll out

            for ( let y = 0; y < date.length; y++){
              // a une end date
              if (consultants[i].user.sageContent.endDate){
                indexEnd = date.indexOf(formateDate(consultants[i].user.sageContent.endDate));
                if(indexStart<=y&&indexEnd>=y){
                  rollOut[y]=rollOut[y]+(y-indexStart)/consultantSommeOverTime[y]
                  //exp = exp + 1
                  //rollOut[y]=rollOut[y]+exp/consultantActive[y]
                }
              }
              // on en a pas ()
              else {
                if(indexStart<=y){
                  //exp = exp + 1
                  //rollOut[y]=rollOut[y]+exp/consultantActive[y]
                  rollOut[y]=rollOut[y]+(y-indexStart)/consultantSommeOverTime[y]
                }
              } 
            }
          }
        }


        /*
        let deletedConsultant = new Array(date.length).fill(0)
        for (let i = 0; i <date.length; i++){
          for (let y = 0; y < consultants.length; y++){
            if(consultants[y].user.sageContent.endDate){
              if (consultants[y].user.sageContent.endDate.substring(0, 7)===date[i]){
                deletedConsultant[i] = deletedConsultant[i] + 1
              }
            }
          }
        }
        // somme des deleted consultant
        let deletedConsultantSomme = deletedConsultant
        for (let i = 1; i <date.length; i++){ 
          deletedConsultantSomme[i] = deletedConsultantSomme[i] + deletedConsultantSomme[i-1]
        }

        let soustraction = consultantSommeOverTime.map ((element, index) => {
          return element - deletedConsultantSomme [index];
        }); */

        
        const options = {
          responsive: true,
          plugins: {
            legend: {
            },
            title: {
              display: true,
              text: this.props.translate('content.extract.dashboard.chart.historicConsultant'),
            },
          },
          scales: {
            y: {
              type: 'linear',
              display: true,
              position: 'left',
            },
            y1: {
              type: 'linear',
              display: true,
              position: 'right',
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        };
        
        const labels = date;

        const data = {
          labels,
          datasets: [
            {
              label: this.props.translate('content.extract.dashboard.chart.onboarding'),
              data: numberOfDate,
              borderColor: 'rgb(255, 99, 132)',
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
              yAxisID: 'y',
              hidden: true,
            },
            {
              label: this.props.translate('content.extract.dashboard.chart.consultant'),
              data: consultantSomme, 
              borderColor: 'rgb(150, 162, 150)',
              backgroundColor: 'rgba(150, 162, 150, 0.5)',
              yAxisID: 'y1',
            },
            /*
            {
              label: 'Somme end date',
              data: deletedConsultantSomme, 
              borderColor: 'rgb(80, 82, 85)',
              backgroundColor: 'rgba(80, 82, 85, 0.5)',
              yAxisID: 'y1',
            },
            {
              label: 'Consultants actifs',
              data: consultantActive, 
              borderColor: 'rgb(10, 50, 250)',
              backgroundColor: 'rgba(10, 50, 250, 0.5)',
              yAxisID: 'y1',
            },*/
            {
              label: this.props.translate('content.extract.dashboard.chart.rollout'),
              data: rollOut, 
              borderColor: 'rgb(180, 102, 85)',
              backgroundColor: 'rgba(180, 102, 85, 0.5)',
              yAxisID: 'y',
            },
          ],
        };

      return (
        <div >
          <Line options={options} data={data} />
        </div>
      )
    }
  }
  
  export default LineChart;
